<script>
  import { createEventDispatcher } from 'svelte';
  import { parameterLabels } from './api.js';

  export let localDraft;
  export let serverDraft = null;
  export let loading = false;
  export let busy = false;
  export let online = true;
  const dispatch = createEventDispatcher();
  let copyNotice = '';

  function summary(draft) {
    if (!draft) return '';
    const mode = { reply: 'Atsakymas klientui', note: 'Privati pastaba', template: 'Patvirtintas šablonas' }[draft.mode];
    return [`Režimas: ${mode}`, ...(draft.template_id ? [`Šablonas: ${draft.template_id}`] : []),
      draft.text, ...Object.entries(draft.parameters || {}).map(([name, value]) => `${parameterLabels[name] || name}: ${value}`)]
      .filter(value => value !== '').join('\n');
  }

  async function copyLocal() {
    try {
      await navigator.clipboard.writeText(summary(localDraft));
      copyNotice = 'Juodraštis nukopijuotas. Kopijoje gali būti asmens duomenų; įklijuokite tik saugioje vietoje.';
    } catch {
      copyNotice = 'Pažymėkite šio įrenginio juodraščio kopiją ir nukopijuokite rankiniu būdu. Originalas liko šiame lange.';
    }
  }
</script>

<section class="draft-conflict" aria-label="Juodraščio konfliktas">
  <h3>Pasirinkite juodraščio versiją</h3>
  <p>Nieko nebus siunčiama klientui. Išsaugojimas pakeis peržiūrėtą serverio versiją;
    serverio versijos pasirinkimas pakeis šiame lange įvestą juodraštį.</p>
  <div class="versions">
    <label>Šio įrenginio juodraščio kopija<textarea readonly rows="3" value={summary(localDraft)}></textarea></label>
    <label>Serverio juodraščio kopija<textarea readonly rows="3" value={summary(serverDraft)}></textarea></label>
  </div>
  {#if loading}<p role="status">Įkeliamas serverio juodraštis…</p>
  {:else if !serverDraft}<p>Serverio versija dar nepasiekiama. Vietinis juodraštis nepakeistas.</p>{/if}
  <div class="actions">
    <button type="button" disabled={!online || loading || busy || !serverDraft} on:click={() => dispatch('choose', 'local')}>Išsaugoti šio įrenginio juodraštį</button>
    <button type="button" disabled={!online || loading || busy || !serverDraft} on:click={() => dispatch('choose', 'server')}>Naudoti serverio juodraštį</button>
    <button type="button" disabled={!online || loading || busy} on:click={() => dispatch('refresh')}>Atnaujinti serverio juodraštį</button>
    <button type="button" on:click={copyLocal}>Kopijuoti šio įrenginio juodraštį</button>
  </div>
  {#if copyNotice}<p role="status">{copyNotice}</p>{/if}
</section>

<style>
  .draft-conflict{border:1px solid #e8d2b0;border-radius:7px;background:#fffbf3;padding:12px;display:flex;flex-direction:column;gap:10px;max-height:340px;overflow:auto}
  h3,p{margin:0}h3{font-size:14px}p{font-size:12px;line-height:1.5}.versions{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:10px}
  label{display:flex;flex-direction:column;gap:5px;font-size:12px}textarea{box-sizing:border-box;width:100%;min-width:0;resize:vertical;max-height:130px;padding:8px;border:1px solid #d5d1cb;border-radius:6px;background:#fff;color:#25231f;font:inherit;line-height:1.5}
  .actions{display:flex;flex-wrap:wrap;gap:7px}button{font:inherit;font-size:12px;padding:8px;border:1px solid #d5d1cb;border-radius:6px;background:#fff;color:#25231f;cursor:pointer}button:disabled{opacity:.5;cursor:not-allowed}button:focus-visible,textarea:focus-visible{outline:2px solid #d95513;outline-offset:2px}
  @media(max-width:760px){.versions{grid-template-columns:1fr}textarea{font-size:16px}.draft-conflict{max-height:300px}}
</style>
